import { Typography } from "@/components/atoms";

export const EmptyBreakdown = () => {
  return (
    <div className="mt-3 w-full rounded-lg border border-neutral-mid-gray p-6">
      <Typography>At the moment, there are no payment breakdown logs available.</Typography>
    </div>
  );
};
